//# sourceMappingURL=/usr/local/google/home/mmalerba/flex-layout/src/lib/media-query/breakpoints/break-point.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angular/flex-layout/media-query/breakpoints/break-point.js
// module id = ./node_modules/@angular/flex-layout/media-query/breakpoints/break-point.js
// module chunks = vendor